module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ub ub-ver uw uh ubgc-main"
  }, [_c('div', {
    staticClass: "ub ub-ver ub-f1 ub-pc ub-ac"
  }, [_c('div', {
    staticClass: "ub ub-pc ufs-24 uc-while umar-t20"
  }, [_vm._v("OKLOK智能锁商城系统")]), _vm._v(" "), _c('div', {
    staticClass: "ub ub-ver upad-40 umar-t20 uh-400 uw-480 ubgc-while ubor-r6"
  }, [_c('div', {
    staticClass: "ub ub-ver uw ub-f1"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    staticClass: "umar-t32",
    attrs: {
      "label": "",
      "prop": "uname"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "size": "large",
      "autofocus": "",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.form.uname),
      callback: function($$v) {
        _vm.$set(_vm.form, "uname", $$v)
      },
      expression: "form.uname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "umar-t32",
    attrs: {
      "label": "",
      "prop": "pword"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "size": "large",
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.form.pword),
      callback: function($$v) {
        _vm.$set(_vm.form, "pword", $$v)
      },
      expression: "form.pword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "umar-t32",
    attrs: {
      "label": "",
      "prop": "code"
    }
  }, [_c('div', {
    staticClass: "ub ub-ac uw"
  }, [_c('el-input', {
    staticClass: "ub ub-f1 umar-r20",
    attrs: {
      "clearable": "",
      "size": "large",
      "placeholder": "请输入验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toLogin('form')
      }
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", _vm._n($$v))
      },
      expression: "form.code"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ub uh-32",
    attrs: {
      "src": _vm.getCodeUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.getCode()
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "ub uw umar-t20 ubor-r ufs-18",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), (_vm.radio.index == 1) ? _c('div', {
    staticClass: "ub ub-ver"
  }, [_c('el-form', {
    ref: "form2",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules2,
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    staticClass: "umar-t32",
    attrs: {
      "label": "",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "size": "large",
      "autofocus": "",
      "maxlength": "11",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "umar-t32",
    attrs: {
      "label": "",
      "prop": "phoneCode"
    }
  }, [_c('div', {
    staticClass: "ub ub-ac uw"
  }, [_c('el-input', {
    staticClass: "ub ub-f1 umar-r20",
    attrs: {
      "clearable": "",
      "size": "large",
      "maxlength": "4",
      "placeholder": "请输入短信验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toLogin()
      }
    },
    model: {
      value: (_vm.form.phoneCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "phoneCode", _vm._n($$v))
      },
      expression: "form.phoneCode"
    }
  }), _vm._v(" "), (!_vm.code.doing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.getPhoneCode()
      }
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.code.doing) ? _c('div', {
    staticClass: "ub uc-grey"
  }, [_vm._v(_vm._s(_vm.code.countdown) + "秒后重新获取")]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "ub uw umar-t20 ubor-r ufs-18",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("登录")])], 1) : _vm._e()])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ufix-b uw",
    staticStyle: {
      "position": "fixed",
      "bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "ub ub-pc upad-10"
  }, [_c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("\n          Copyright ©2025 深圳市龙兄弟数码锁有限公司  版权所有\n          "), _c('a', {
    staticStyle: {
      "color": "#666",
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/",
      "rel": "nofollow",
      "looyu_bound": "1"
    }
  }, [_vm._v("粤ICP备18016736号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79892924","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 661
// module chunks = 30